import Splide from '@splidejs/splide';

export const initSolutionsSlider = () => {
  const offersSliderEl = document.querySelector(
    '[data-pro-multifamily-overview-solutions-slider]'
  );

  const offersSlider = new Splide(offersSliderEl, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 800,
    gap: 20,
    arrows: false,
    pagination: true,
    classes: {
      pagination: 'pro-multifamily-overview-solutions__slider-pagination',
      page: 'pro-multifamily-overview-solutions__slider-pagination-btn',
    },
  });

  offersSlider.mount();

  const tabs = document.querySelectorAll(
    '[data-pro-multifamily-overview-solutions-tab]'
  );

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      offersSlider.go(index);
    });
  });

  offersSlider.on('move', (newIndex, prevIndex) => {
    tabs[prevIndex].setAttribute('data-active', 'false');
    tabs[newIndex].setAttribute('data-active', 'true');
  });
};
